import React, {Component, Fragment} from "react";
import QrReader from 'react-qr-reader';
import Div100vh from "../../../../uq-ui/components/div-100";
import LayoutComponentsHeader from "../../../../layout/ui/components/header";
import * as styles from "./style.css";

class BusinessScreensScanSticker extends Component {
  state = {
    error: null
  };

  handleScan = data => {
    if (data) {
      try {
        const url = new URL(data);
        const splitted = url.pathname.split("/");
        const stickerId = splitted[1];
        this.props.history.push('/business/send-link-by-sms', {stickerId});
      } catch (e) {
        this.setState({error: "Invalid URL"})
      }
    }
  };

  handleError = err => {
    this.setState({error: "Failed to Scan or open Camera"})
  };

  render() {
    return (
      <Fragment>
        <LayoutComponentsHeader showBackBtn={false}/>
        <Div100vh className={styles.page} style={{minHeight: '100rvh'}}>
          <div className={styles.header}>
            <div className={`${styles.title} font-title`}
                 dangerouslySetInnerHTML={{__html: "Please scan<br>Llama QR"}}/>
          </div>
          <div className={styles.qrContainer}>
            <QrReader
              delay={300}
              onError={this.handleError}
              onScan={this.handleScan}
              style={{width: '80%'}}
            />
          </div>
          <div className={styles.errorContainer}>
            {this.state.error ? this.state.error : ""}
          </div>
        </Div100vh>
      </Fragment>
    )
  }
}

export default BusinessScreensScanSticker;



// WEBPACK FOOTER //
// ./src/app/modules/business/ui/screens/scan-sticker/index.jsx